.screen {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card {
  width: 600px;
  padding: 36px 40px 32px;
}
.heading {
  margin: 8px 0 12px;
  font-family: var(--font-heading);
  font-size: 34px;
  font-weight: 600;
  color: var(--color-text);
}
.note {
  margin: 0 0 20px;
  font-size: 15px;
  line-height: 1.5;
  color: var(--color-neutral-700);
}
.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}
.input {
  height: 56px;
  padding: 0 16px;
  font: inherit;
  font-size: 20px;
  color: var(--color-text);
  background: var(--color-neutral-100);
  border: 2px solid var(--color-neutral-300);
  border-radius: var(--radius-md, 12px);
  outline: none;
}
.input:focus {
  border-color: var(--color-accent);
}
.input:disabled {
  opacity: 0.6;
}
.code {
  width: 200px;
  letter-spacing: 0.5em;
  font-size: 26px;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}
.error {
  margin-top: 18px;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-danger-700);
  background: var(--color-danger-100);
  border-radius: var(--radius-md, 12px);
}
.rows {
  margin: 0 0 20px;
}
.rows > div {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid var(--color-divider);
}
.rows dt {
  font-size: 12px;
  font-weight: 700;
  color: var(--color-neutral-600);
}
.rows dd {
  margin: 0;
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
}

/* The ways in from the sign-in screen: small, out of the operators' way. */
.setupLinks {
  position: absolute;
  right: 32px;
  bottom: 20px;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 16px;
}
.updateLink {
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  background: var(--color-accent);
  color: var(--color-surface);
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-decoration: none;
}
